module.exports = {
    API_TOKEN: process.env.REACT_APP_API_TOKEN,
    URL_BACKEND: process.env.REACT_APP_URL_BACKEND,
    API_NODE: process.env.REACT_APP_API_NODE,
    API_GRAPHQL: process.env.REACT_APP_API_GRAPHQL,
    URL_TOTVS: process.env.REACT_APP_URL_TOTVS,
    DEBUG: process.env.REACT_APP_DEBUG,
    GATEWAY_API_KEY: process.env.REACT_APP_GATEWAY_API_KEY
};
